export default __webpack_public_path__ + "static/media/redemption_navicon.1ba28eb0.svg";